import React from 'react';

import { cn } from '@/src/util/ui';

const InputWithLabelLayout = ({
  label,
  inputName = '',
  isRequired = false,
  LastComponentSlot = null,
  children,
}) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-[10px] tw-mb-[10px]">
      <label
        htmlFor={inputName}
        className={cn(
          'tw-min-w-[50px] tw-m-0 tw-font-brandonTextMedium !tw-font-medium tw-text-cfo-black'
        )}
      >
        <span>
          {label}
          {isRequired && <span className="tw-text-cfo-red-400">*</span>}
        </span>
      </label>
      {children}
      <div className="tw-w-[17px]">{LastComponentSlot}</div>
    </div>
  );
};

export default InputWithLabelLayout;
